export default __webpack_public_path__ + "static/media/default-user.a6143582.png";